var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalculator(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 32,
    viewBox: "0 0 26 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 5.5H7C6.17157 5.5 5.5 6.17157 5.5 7V25C5.5 25.8284 6.17157 26.5 7 26.5H19C19.8284 26.5 20.5 25.8284 20.5 25V7C20.5 6.17157 19.8284 5.5 19 5.5ZM7 4C5.34315 4 4 5.34315 4 7V25C4 26.6569 5.34315 28 7 28H19C20.6569 28 22 26.6569 22 25V7C22 5.34315 20.6569 4 19 4H7Z",
    fill: "#FDF9F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 7.75C7 7.33579 7.33579 7 7.75 7H18.25C18.6642 7 19 7.33579 19 7.75V10.75C19 11.1642 18.6642 11.5 18.25 11.5H7.75C7.33579 11.5 7 11.1642 7 10.75V7.75Z",
    fill: "#FDF9F3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 13.75C7 13.3358 7.33579 13 7.75 13H9.25C9.66421 13 10 13.3358 10 13.75V15.25C10 15.6642 9.66421 16 9.25 16H7.75C7.33579 16 7 15.6642 7 15.25V13.75Z",
    fill: "#FDF9F3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 18.25C7 17.8358 7.33579 17.5 7.75 17.5H9.25C9.66421 17.5 10 17.8358 10 18.25V19.75C10 20.1642 9.66421 20.5 9.25 20.5H7.75C7.33579 20.5 7 20.1642 7 19.75V18.25Z",
    fill: "#FDF9F3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7 22.75C7 22.3358 7.33579 22 7.75 22H9.25C9.66421 22 10 22.3358 10 22.75V24.25C10 24.6642 9.66421 25 9.25 25H7.75C7.33579 25 7 24.6642 7 24.25V22.75Z",
    fill: "#FDF9F3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 13.75C11.5 13.3358 11.8358 13 12.25 13H13.75C14.1642 13 14.5 13.3358 14.5 13.75V15.25C14.5 15.6642 14.1642 16 13.75 16H12.25C11.8358 16 11.5 15.6642 11.5 15.25V13.75Z",
    fill: "#FDF9F3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 18.25C11.5 17.8358 11.8358 17.5 12.25 17.5H13.75C14.1642 17.5 14.5 17.8358 14.5 18.25V19.75C14.5 20.1642 14.1642 20.5 13.75 20.5H12.25C11.8358 20.5 11.5 20.1642 11.5 19.75V18.25Z",
    fill: "#FDF9F3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 22.75C11.5 22.3358 11.8358 22 12.25 22H13.75C14.1642 22 14.5 22.3358 14.5 22.75V24.25C14.5 24.6642 14.1642 25 13.75 25H12.25C11.8358 25 11.5 24.6642 11.5 24.25V22.75Z",
    fill: "#FDF9F3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16 13.75C16 13.3358 16.3358 13 16.75 13H18.25C18.6642 13 19 13.3358 19 13.75V15.25C19 15.6642 18.6642 16 18.25 16H16.75C16.3358 16 16 15.6642 16 15.25V13.75Z",
    fill: "#FDF9F3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16 18.25C16 17.8358 16.3358 17.5 16.75 17.5H18.25C18.6642 17.5 19 17.8358 19 18.25V24.25C19 24.6642 18.6642 25 18.25 25H16.75C16.3358 25 16 24.6642 16 24.25V18.25Z",
    fill: "#FDF9F3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculator);
export default __webpack_public_path__ + "static/media/calculator.d1c0ca45.svg";
export { ForwardRef as ReactComponent };